import React from "react";

import "../css/ContactInfoCard.css";

const ContactInfoCard = () => {
  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert("Copied to clipboard: " + text);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div class="card w-100 h-auto contact-info">
      <div class="card-body bg-dark text-white">
        <h5 class="card-title">Cesar Ernesto Jimenez Acosta</h5>
        <p className="card-text">
          LinkedIn:{" "}
          <a
            href="https://www.linkedin.com/in/cesar-jimenez-b07b7b52"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.linkedin.com
          </a>
        </p>
        <p
          className="card-text underline"
          onClick={() => copyToClipboard("aguiladescalza@gmail.com")}
        >
          Email: aguiladescalza@gmail.com
        </p>
        <p class="card-text">Phone: +52 (663) 436-1254</p>
        {/*<a href="#" class="btn btn-primary">Go somewhere</a>*/}
      </div>
    </div>
  );
};

export default ContactInfoCard;
